import { useState } from "react";
import { connect } from "react-redux";
import logo from "../../images/logo.png";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { setLogout } from "../../store/thunk/user";

const Header = ({ user, setLogout }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const goTo = (link) => {
    navigate(link);
  };
  // Toggle the sidebar open/close state
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <>
      <header className="p-4 border-bottom d-flex justify-content-between align-items-center">
        <a
          onClick={e => {
            e.preventDefault();
            user?.token ? navigate("/dashboard") : navigate("/login");
          }}
          className="d-flex align-items-center text-dark text-decoration-none cursor"
        >
          <img src={logo} alt="main cpc portal logo" style={{ height: "60px"}} />
          &nbsp;&nbsp;<span className="fs-4">Rapid Resourcing LTD</span>
        </a>
        {/* Menu Icon */}
        {user?.token && (
          <button className="menu-icon" onClick={toggleSidebar}>
            &#9776; {/* Unicode for hamburger icon */}
          </button>
        )}
      </header>

      {/* Sidebar */}
      {user?.token && (
        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          <button className="close-btn" onClick={toggleSidebar}>
            &times; {/* Unicode for close icon */}
          </button>
          <ul className="sidebar-menu">
            <li>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  goTo("/dashboard");
                }}
              >
                Dashboard
              </a>
            </li>
            <li>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setLogout();
                  goTo("/");
                }}
              >
                Logout
              </a>
            </li>
          </ul>
        </div>
      )}

      {/* Overlay to close sidebar when clicked outside */}
      {isSidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </>
  );
};
const mapStateToProps = (state) => ({
  user: state.user.loggedInUserData,
});

export default connect(mapStateToProps, { setLogout })(Header);
